module.exports = __webpack_public_path__ + "img/cooperate_19.66e5a4a8.png";